import React from 'react';
import { Box, InputLabel } from '@material-ui/core';
import ButtonIcon from 'components/IconButton';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const IconWithText = ({
  title,
  classes,
  component,
  onClick,
  showText = false,
  theme,
  text,
  testid,
}) => {
  const { t } = useTranslation();
  return (
    <Box display={'flex'} flexDirection={'column'} alignItems={'flex-start'}>
      <Box display={'inline-block'}>
        {showText && (
          <InputLabel
            shrink={true}
            htmlFor={title}
            focused={false}
            classes={{ root: classes }}
          >
            {t(title)}
          </InputLabel>
        )}
      </Box>

      <ButtonIcon
        onClick={onClick}
        data-testid={testid}
        component={component}
        text={text}
        size={'m'}
        noHorizontalPadding
        iconProps={{
          fontSize: 'inherit',
        }}
        theme={theme}
      />
    </Box>
  );
};
IconWithText.propTypes = {
  title: PropTypes.string,
  classes: PropTypes.string,
  component: PropTypes.elementType,
  onClick: PropTypes.func,
  showText: PropTypes.bool,
  theme: PropTypes.string,
  text: PropTypes.string,
  testid: PropTypes.string,
};
export default IconWithText;
